import { useMemo } from "react";
import { SubscriptionType, UpsellPanelContent, UserAccessLevelType } from "../../../constants/upsellPanelEnumsAndConstants";
import { useRouteInitialData } from "../../../hooks/useRouteInitialData";
import { getTargetBUID } from "../../../utils/utils";

const useUpsellBaseModel = () => {
    const {
        currentStep,
        downloadFileId,
        entryPoint,
        ignoreSMSRequestValidation,
        productHandle = SubscriptionType.SUBSCRIPTION_TRIAL_PRODUCT,
        requiredAccessLevel = UserAccessLevelType.Anonymous,
        user
    } = useRouteInitialData();
    const model = useMemo(() => {
        return {
            content: {
                loginParagraph: UpsellPanelContent.PLEASE_LOGIN_TO_CONTINUE,
                trialHeading: UpsellPanelContent.UPSELL_TRIAL_HEADING,
                upgradeHeading: UpsellPanelContent.UPSELL_UPGRADE_HEADING,
            },
            couponCode: '',
            currentStep: Number(currentStep ?? 0),
            byPassPhoneVerification: false,
            borderBlur: true,
            displayErrorPanel: true,
            displayHowFoundList: false,
            displayLoginMessage: true,
            displayQuestionAllSteps: false,
            displayReferralCodeField: false,
            displayUpsellFooter: true,
            downloadFileId,
            entryPoint,
            eventId: null,
            existingSubscriberText: UpsellPanelContent.EMAIL_REGISTERED_ERROR_MSG,
            existingSubscriberParagraph: UpsellPanelContent.PLEASE_LOGIN_TO_CONTINUE,
            getExtraProducts: false,
            hideBrandIcons: true,
            hideLogin: false,
            howFoundRequired: false,
            isCompetitionPage: false,
            ignoreSMSRequestValidation,
            investmentQuizGoalTypeID: null,
            isDebug: false,
            mobileRequired: true,
            popupMustLogin: true,
            loginText: "Log in ",
            noLoginText: false,
            passwordRequired: false,
            productHandle: productHandle,
            requiredAccessLevel,
            returnUrl: '',
            secondaryButtonsVertical: true,
            subButtonText: UpsellPanelContent.ALREADY_A_MEMBER,
            targetUrl: null,
            targetUrl2: null,
            targetBuid: getTargetBUID(),
            timeToInitialDisplay: null,
            useInsightsArticleOverlay: false,
            usePopupOverlayV2: false,
            user: user ?? {}
        };
    }, []);

    return model;
};
export default useUpsellBaseModel;
